<script setup>
import { defineProps, computed, ref } from "vue";

const props = defineProps({
  inventory: Array,
});

const searchField = ref("");

let defaultHeaders = [
  { title: "Application", value: "application", enabled: true, sortable: true },
  {
    title: "Application ID",
    value: "CFBundleIdentifier",
    enabled: true,
    sortable: true,
  },
  {
    title: "Version",
    value: "CFBundleShortVersionString",
    enabled: true,
    sortable: true,
  },
  { title: "Path", value: "path", enabled: true, sortable: true },
  {
    title: "From Mac App Store",
    value: "fromMacAppStore",
    enabled: true,
    sortable: true,
  },
];

function getAppNameFromPath(path) {
  // Get the last part of the path
  const lastPart = path.split("/").pop();
  // Remove the .app extension if present
  if (lastPart && lastPart.endsWith(".app")) {
    return lastPart.slice(0, -4);
  }
  return lastPart || null;
}

let filteredHeaders = computed(() => {
  return defaultHeaders.filter((header) => header.enabled);
});

const filteredInventory = computed(() => {
  if (!searchField.value)
    return props.inventory.map((item) => {
      return {
        ...item,
        application: getAppNameFromPath(item.path),
      };
    });
  const search = searchField.value.toLowerCase();
  var result = props.inventory.filter((item) => {
    return (
      getAppNameFromPath(item.path)?.toLowerCase().includes(search) ||
      item.CFBundleIdentifier?.toLowerCase().includes(search) ||
      item.CFBundleShortVersionString?.toLowerCase().includes(search) ||
      item.path?.toLowerCase().includes(search)
    );
  });
  return result.map((item) => {
    return {
      ...item,
      application: getAppNameFromPath(item.path),
    };
  });
});
</script>

<template>
  <v-row class="my-3">
    <v-col cols="3">
      <v-sheet rounded>
        <v-text-field
          density="compact"
          hide-details
          prepend-inner-icon="mdi-magnify"
          v-model="searchField"
          placeholder="Search..."
          variant="outlined"
        ></v-text-field>
      </v-sheet>
    </v-col>
    <v-spacer></v-spacer>
  </v-row>

  <v-sheet rounded>
    <v-data-table :headers="filteredHeaders" :items="filteredInventory">
      <template v-slot:[`item.fromMacAppStore`]="{ item }">
        <div v-if="item.fromMacAppStore">Yes</div>
        <div v-else>No</div>
      </template>
    </v-data-table>
  </v-sheet>
</template>
